import { render, staticRenderFns } from "./TurnDetails.vue?vue&type=template&id=dfadb7d4&"
import script from "./TurnDetails.vue?vue&type=script&lang=js&"
export * from "./TurnDetails.vue?vue&type=script&lang=js&"
import style0 from "./TurnDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports